import OrdemServicoEnderecoService from "@/services/OrdemServicoEnderecoService";

export const ordemServicoEndereco = {
  namespaced: true,
  state: {
    ordemServicoEndereco: {},
  },
  actions: {
    getOrdemServicoEndereco({ commit }, payload) {
      return OrdemServicoEnderecoService.GetOrdemServicoEndereco(payload).then(
        (ordemServicoEndereco) => {
          return Promise.resolve(ordemServicoEndereco);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postOrdemServicoEndereco({ commit }, payload) {
      return OrdemServicoEnderecoService.PostOrdemServicoEndereco(payload).then(
        (ordemServicoEndereco) => {
          return Promise.resolve(ordemServicoEndereco);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putOrdemServicoEndereco({ commit }, payload) {
      return OrdemServicoEnderecoService.PutOrdemServicoEndereco(payload).then(
        (ordemServicoEndereco) => {
          return Promise.resolve(ordemServicoEndereco);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteOrdemServicoEndereco({ commit }, payload) {
      return OrdemServicoEnderecoService.DeleteOrdemServicoEndereco(
        payload
      ).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getOrdemServicoEnderecoOData({ commit }, payload) {
      return OrdemServicoEnderecoService.GetOrdemServicoEnderecoOData(
        payload
      ).then(
        (ordemServicoEndereco) => {
          return Promise.resolve(ordemServicoEndereco);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default ordemServicoEndereco;
